import React from 'react';
export function Footer() {
  return <footer className="bg-gray-100 text-gray-700 py-8 px-4 mt-12 border-t border-gray-200" data-id="element-183">
      <div className="max-w-5xl mx-auto" data-id="element-184">
        {/* Navigation Links */}
        <div className="flex flex-wrap justify-center gap-6 mb-6" data-id="element-185">
          <a href="https://www.physique-building.com/privacy-policy31819446?_gl=1%2A15d9s0i%2A_gcl_au%2AMzkwOTUwMDYuMTc0ODc0OTc4Mw.." className="text-blue-600 hover:underline" data-id="element-186">
            Privacy Policy
          </a>
          <a href="#" className="text-blue-600 hover:underline" data-id="element-187">
            Contact Us
          </a>
          <a href="https://www.physique-building.com/terms-of-service31819595?_gl=1%2Aoe23ur%2A_gcl_au%2AMzkwOTUwMDYuMTc0ODc0OTc4Mw.." className="text-blue-600 hover:underline" data-id="element-188">
            Terms of Service
          </a>
        </div>
        {/* Disclaimers */}
        <div className="text-xs text-center space-y-4 mb-6" data-id="element-189">
          <p className="font-semibold" data-id="element-190">
            This Site Is NOT Associated With Facebook.
          </p>
          <p data-id="element-191">
            This site is not part of, or endorsed by, Facebook, Google,
            Snapchat, Twitter or any social media platform in any way.
          </p>
          <p data-id="element-192">
            All product names, logos, and brands are property of their
            respective owners. All company, product and service names used in
            this website are for identification purposes only. Use of these
            names, logos, and brands does not imply endorsement.
          </p>
          <p data-id="element-193">
            FACEBOOK is a trademark of META, Inc. YOUTUBE and GOOGLE are
            trademarks of GOOGLE, LLC. SNAPCHAT is a trademark of SNAP, Inc.
            TWITTER is a trademark of TWITTER, Inc.
          </p>
        </div>
        {/* Copyright */}
        <div className="text-center text-xs" data-id="element-194">
          <p className="font-semibold" data-id="element-195">PHYSIQUE BUILDING © 2025</p>
          <p data-id="element-196">physiquebuilding.com</p>
        </div>
      </div>
    </footer>;
}